import { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Fullscreen image viewer for message attachments.
 *
 * Closes on Escape, on the scrim, or on the close button. Rendered only when a
 * `src` is supplied, so it costs nothing while closed.
 */
export default function ImageLightbox({ src, alt = 'Shared image', onClose }) {
  useEffect(() => {
    if (!src) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={alt}
      onClick={onClose}
      className="fixed inset-0 z-[60] flex items-center justify-center bg-overlay-strong p-5 backdrop-blur-sm"
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Close image"
        className="absolute top-4 right-4 grid h-10 w-10 place-items-center rounded-xl bg-white/10 text-white transition hover:bg-white/20"
      >
        <X size={18} />
      </button>

      <img
        src={src}
        alt={alt}
        onClick={(event) => event.stopPropagation()}
        className="animate-z2-rise max-h-[88vh] max-w-[92vw] rounded-2xl shadow-2xl"
      />
    </div>
  );
}
